import { defineMessages } from "react-intl";

export const messages = defineMessages({
  title: {
    id: "yb+1HB",
    defaultMessage: "Taxes",
    description: "wizard step title",
  },
  description: {
    id: "9DgAm/",
    defaultMessage: "Configure basic tax settings for your storefront.",
    description: "wizard step description",
  },
  noConfigDescription: {
    id: "nJTeh0",
    defaultMessage: "No tax configuration found for your channel.",
    description: "wizard step description when no tax config",
  },
  successMessage: {
    id: "p++72M",
    defaultMessage: "Tax configuration saved",
    description: "wizard step success notification",
  },
  errorMessage: {
    id: "qlk+sF",
    defaultMessage: "Failed to save tax configuration",
    description: "wizard step error notification",
  },
  warningMessage: {
    id: "OhD3Td",
    defaultMessage: "No tax configuration found. Skipping.",
    description: "wizard step warning notification",
  },
  noConfigFallback: {
    id: "inW0RQ",
    defaultMessage:
      "Tax configuration will be available after your channel is fully set up. You can skip this step and configure taxes later from the Configuration menu.",
    description: "fallback text when no tax config exists",
  },
  chargeTaxes: {
    id: 'y5IyLG',
    defaultMessage: "Charge taxes for this channel",
    description: "form checkbox label",
  },
  taxStrategyHint: {
    id: '+/0vHL',
    defaultMessage: "Select the method of tax calculation",
    description: "tax strategy select hint",
  },
  enteredPrices: {
    id: 'S0wgHp',
    defaultMessage: "Entered prices",
    description: "form section label",
  },
  pricesWithTaxLabel: {
    id: 'ZrcqGQ',
    defaultMessage: "Product prices are entered with tax",
    description: "radio button label",
  },
  pricesWithoutTaxLabel: {
    id: 'pGUQNx',
    defaultMessage: "Product prices are entered without tax",
    description: "radio button label",
  },
  renderedPrices: {
    id: '4pOKxD',
    defaultMessage: "Rendered prices",
    description: "form section label",
  },
  displayGrossPrices: {
    id: '5clsVv',
    defaultMessage: "Show gross prices in storefront",
    description: "form checkbox label",
  },
});
